var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPersonalFinance = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Saving-Piggy-Bank--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Saving Piggy Bank Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 9.28a1 1 0 0 0 -0.92 -1.07 1 1 0 0 0 -1.08 0.92 0.14 0.14 0 0 1 -0.13 0.13 0.15 0.15 0 0 1 -0.15 -0.11 8.22 8.22 0 0 0 -2.87 -4.22 11.12 11.12 0 0 0 -8.91 -2.11 0.26 0.26 0 0 1 -0.25 -0.1A4 4 0 0 0 5.5 1.25a1 1 0 0 0 -0.72 0.75 1 1 0 0 0 0.28 1 3.05 3.05 0 0 1 0.8 1.26 0.25 0.25 0 0 1 -0.1 0.28A8.31 8.31 0 0 0 2.2 9.43a0.24 0.24 0 0 1 -0.2 0.19h-0.5a1.5 1.5 0 0 0 -1.5 1.5v2a1.5 1.5 0 0 0 1.5 1.5h1.24a0.25 0.25 0 0 1 0.22 0.13A8.82 8.82 0 0 0 6.07 18a0.26 0.26 0 0 1 0.11 0.29l-0.88 3a1.26 1.26 0 0 0 0.85 1.55 1.45 1.45 0 0 0 0.35 0A1.25 1.25 0 0 0 7.7 22l0.77 -2.65a0.29 0.29 0 0 1 0.12 -0.15 0.31 0.31 0 0 1 0.19 0 11.4 11.4 0 0 0 3.22 0.47 11.29 11.29 0 0 0 3.22 -0.46 0.24 0.24 0 0 1 0.19 0 0.22 0.22 0 0 1 0.12 0.15L16.3 22a1.25 1.25 0 0 0 1.2 0.9 1.45 1.45 0 0 0 0.35 0 1.26 1.26 0 0 0 0.85 -1.55l-0.88 -3a0.24 0.24 0 0 1 0.11 -0.28 8.36 8.36 0 0 0 4 -5.92 0.24 0.24 0 0 1 0.15 -0.2A3 3 0 0 0 24 9.28Zm-6.9 -1.7a0.76 0.76 0 0 1 -0.6 0.29 0.68 0.68 0 0 1 -0.45 -0.15 6.82 6.82 0 0 0 -4.5 -1.33 0.74 0.74 0 0 1 -0.8 -0.7 0.76 0.76 0 0 1 0.7 -0.8A8.24 8.24 0 0 1 17 6.53a0.75 0.75 0 0 1 0.1 1.05ZM6 10.62a1 1 0 1 1 1 -1 1 1 0 0 1 -1 1Z",
    fill: "currentColor",
    strokeWidth: 1
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPersonalFinance);
export default ForwardRef;